var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { MandateType } from '../config/mandate';
import API from '../util/ApiUtil';
class RepresentationStore {
    constructor(rootStore) {
        Object.defineProperty(this, "hasDiilAccounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasDiilServices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasDiilServicesMandates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "accountsStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITALIZED'
        });
        Object.defineProperty(this, "servicesStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITALIZED'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleAccountsSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                this.hasDiilAccounts = response.data;
                this.accountsStatus = 'FETCHED';
            }
        });
        Object.defineProperty(this, "handleAccountsError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                this.accountsStatus = 'ERROR';
                console.error(error);
            }
        });
        Object.defineProperty(this, "handleProductsExistenceSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                this.hasDiilServices = response.data;
                this.servicesStatus = 'FETCHED';
            }
        });
        Object.defineProperty(this, "handleProductsExistenceError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                this.servicesStatus = 'ERROR';
                console.error(error);
            }
        });
        makeObservable(this);
        this.ssoStore = rootStore.ssoStore;
        this.mandateStore = rootStore.mandateStore;
    }
    async fetchAccountsAndProductsExistence() {
        await this.mandateStore.loadMandateInfo([MandateType.LEGAL, MandateType.SERVICE, MandateType.USER], false);
        this.hasServicesMandates();
        if (!this.ssoStore.isDealer) {
            await this.fetchDiilAccountsExistence();
            if (this.shouldFetchDiilProductsExistence()) {
                await this.fetchDiilProductsExistence();
            }
        }
    }
    shouldFetchDiilProductsExistence() {
        return this.hasDiilAccounts && this.hasDiilServicesMandates;
    }
    async fetchDiilAccountsExistence() {
        this.accountsStatus = 'FETCHING';
        await API.get('/accounts/has-diil-accounts').then(this.handleAccountsSuccess).catch(this.handleAccountsError);
    }
    async fetchDiilProductsExistence() {
        this.servicesStatus = 'FETCHING';
        await API.get('/product-summary/has-diil-products').then(this.handleProductsExistenceSuccess).catch(this.handleProductsExistenceError);
    }
    hasServicesMandates() {
        this.hasDiilServicesMandates = this.mandateStore.hasMandate([MandateType.LEGAL, MandateType.SERVICE, MandateType.USER], false);
    }
    get showNotice() {
        if (this.ssoStore.isDealer) {
            return false;
        }
        return (!this.ssoStore.isPrivateCustomer ||
            (this.ssoStore.loggedIn && this.isFetched() && !this.hasFetchErrors && (!this.hasDiilAccounts || (this.hasDiilServicesMandates && !this.hasDiilServices))));
    }
    get hasFetchErrors() {
        return this.accountsStatus === 'ERROR' || this.servicesStatus === 'ERROR';
    }
    isFetched() {
        return this.accountsStatus === 'FETCHED' && (!this.shouldFetchDiilProductsExistence() || this.servicesStatus === 'FETCHED');
    }
    get isLoading() {
        const loadingStatuses = ['FETCHING'];
        return loadingStatuses.includes(this.accountsStatus) || loadingStatuses.includes(this.servicesStatus);
    }
}
__decorate([
    observable
], RepresentationStore.prototype, "hasDiilAccounts", void 0);
__decorate([
    observable
], RepresentationStore.prototype, "hasDiilServices", void 0);
__decorate([
    observable
], RepresentationStore.prototype, "hasDiilServicesMandates", void 0);
__decorate([
    observable
], RepresentationStore.prototype, "accountsStatus", void 0);
__decorate([
    observable
], RepresentationStore.prototype, "servicesStatus", void 0);
__decorate([
    action.bound
], RepresentationStore.prototype, "fetchAccountsAndProductsExistence", null);
__decorate([
    action.bound
], RepresentationStore.prototype, "fetchDiilAccountsExistence", null);
__decorate([
    action.bound
], RepresentationStore.prototype, "handleAccountsSuccess", void 0);
__decorate([
    action.bound
], RepresentationStore.prototype, "handleAccountsError", void 0);
__decorate([
    action.bound
], RepresentationStore.prototype, "fetchDiilProductsExistence", null);
__decorate([
    action.bound
], RepresentationStore.prototype, "handleProductsExistenceSuccess", void 0);
__decorate([
    action.bound
], RepresentationStore.prototype, "handleProductsExistenceError", void 0);
__decorate([
    action.bound
], RepresentationStore.prototype, "hasServicesMandates", null);
__decorate([
    computed
], RepresentationStore.prototype, "showNotice", null);
__decorate([
    computed
], RepresentationStore.prototype, "hasFetchErrors", null);
__decorate([
    computed
], RepresentationStore.prototype, "isLoading", null);
export default RepresentationStore;
